import { useTranslation } from 'react-i18next';
import { classicUrl } from '@/utils/classicLinks';

export const useTacticsNavigationItem = () => {
  const { t } = useTranslation('navigation');

  return {
    id: 'tactics',
    icon: 'IqTactics' as const,
    path: classicUrl('engine-room'),
    label: t('crossPlatform.primary.tactics'),
  };
};
